module.exports = __webpack_public_path__ + "img/air-freight.eb9e10cb.png";